import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Grid,
  CardHeader,
  Container,
  CardActions,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tooltip,
} from '@mui/material'
import GlobalStyles from '@mui/material/GlobalStyles';
import CssBaseline from '@mui/material/CssBaseline';
import Page from '../../../components/Page';
import InfoIcon from '@mui/icons-material/Info';


import PaymentService from '../../../services/payment_service'

const PaymentPeriod = () => {



  const [subscriptionPlans, setSubscriptionsPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [months, setMonths] = useState({});
  const [prices, setPrices] = useState({});
  const [startPrices, setStartPrices] = useState({});

  function getDiscount(month) {
    if (month === 1) {
      return 1.0
    } else if (month === 3) {
      return 0.95;
    } else if (month === 6) {
      return 0.9;
    } else if (month === 9) {
      return 0.85;
    } else if (month === 12) {
      return 0.8;
    } else {
      return 1.0
    }
  }

  const handleChangeMonths = (event, month) => {
    let m = event.target.value;
    let id = event.target.name;
    months[id] = m;
    let newPrice = parseFloat(startPrices[id]) * getDiscount(m) * parseInt(m);
    prices[id] = parseInt(newPrice);
    setPrices(prices);

    setPrices(prevState => ({ ...prevState, name: newPrice }))

    // setMonths(event.target.value);
  };

  function setupData(data) {
    setSubscriptionsPlans(data);
    for (let i = 0; i < data.length; i++) {
      let id = data[i].id;
      prices[id] = data[i].price;
      startPrices[id] = data[i].price;
    }
  }

  function fetchSubscriptionPlans() {
    PaymentService.getSubscriptionPlans()
      .then((response) => response.data)
      .then((data) => setupData(data['data']))
      .then((data) => setIsLoading(false))
      .catch((error) => console.log(error))
  }

  function payByLink(subscription_plan_id, months) {
    PaymentService.getPaymentLink(subscription_plan_id, months)
      .then((response) => response.data)
      .then((data) => window.location.replace(data['url']))
      .catch((error) => console.log(error))
  }


  function handleSelectPayment(plan_id, months) {
    payByLink(plan_id, months)
  }

  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);




  return (
    <Page title="Payment">
      <GlobalStyles styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }} />
      <CssBaseline />
      <Container disableGutters maxWidth="sm" component="main" sx={{ pt: 8, pb: 6 }}>
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="text.primary"
          gutterBottom
        >
          Pricing
        </Typography>
        <Typography variant="h5" align="center" color="text.secondary" component="p">
          Select the subscription plan that aligns perfectly with your unique requirements and budget
        </Typography>
      </Container>
      <Container maxWidth="md" component="main">
        <Grid container spacing={5} alignItems="flex-end">
          {subscriptionPlans.map((plan) => (
            // Enterprise card is full width at sm breakpoint
            <Grid
              item
              key={plan.name}
              xs={12}
              sm={plan.popular ? 12 : 6}
              md={4}
            >
              <Card>
                <CardHeader
                  title={plan.name}
                  subheader={plan.subheader}
                  titleTypographyProps={{ align: 'center' }}
                  subheaderTypographyProps={{
                    align: 'center',
                  }}
                  sx={{
                    backgroundColor: (theme) =>
                      theme.palette.mode === 'light'
                        ? theme.palette.grey[200]
                        : theme.palette.grey[700],
                  }}
                />
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'baseline',
                      mb: 2,
                    }}
                  >
                    <Typography component="h2" variant="h3" color="text.primary">
                      ${plan.price}
                    </Typography>
                    <Typography variant="h6" color="text.secondary">
                      /mo
                    </Typography>
                  </Box>
                  <ul>
                    {plan.description.split('\\n').map((line) => (
                      <Typography
                        component="li"
                        variant="subtitle1"
                        align="center"
                        key={line}
                      >
                        {line}
                      </Typography>
                    ))}
                  </ul>

                  <FormControl fullWidth sx={{ mt: 3 }}>
                    <InputLabel id="select-label">Months</InputLabel>
                    <Select
                      label="Months"
                      labelId="rating-label"
                      id="rating-select"
                      name={plan.id}
                      value={months[plan.id]}
                      onChange={handleChangeMonths}
                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={6}>6</MenuItem>
                      <MenuItem value={12}>12</MenuItem>
                    </Select>
                  </FormControl>
                </CardContent>
                <CardActions>
                  {plan.helpmessage ? <Tooltip title={plan.helpmessage}>
                    <Box component="span" sx={{ m: 2, width: '100%', }}>
                      <Button fullWidth disabled={!plan.active} variant="outlined" onClick={() => {
                        handleSelectPayment(plan.id, months[plan.id])
                      }} endIcon={<InfoIcon />}>
                        Select for ${prices[plan.id]}
                      </Button>
                    </Box>
                  </Tooltip> : 
                  <Box component="span" sx={{ m: 2, width: '100%', }}><Button fullWidth disabled={!plan.active} variant="outlined" onClick={() => {
                    handleSelectPayment(plan.id, months[plan.id])
                  }} >
                    Select for ${prices[plan.id]}
                  </Button>
                  </Box>}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Page >
  );
};

export default PaymentPeriod;
